/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsData } from '../../models/submissions-data';
import { SubmissionsDataCreate } from '../../models/submissions-data-create';

export interface CreateSubmissionDataApiV2SubmissionsOrgIdDataPost$Params {
  id: string;
  org: string;
      body: SubmissionsDataCreate
}

export function createSubmissionDataApiV2SubmissionsOrgIdDataPost(http: HttpClient, rootUrl: string, params: CreateSubmissionDataApiV2SubmissionsOrgIdDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionsData>> {
  const rb = new RequestBuilder(rootUrl, createSubmissionDataApiV2SubmissionsOrgIdDataPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionsData>;
    })
  );
}

createSubmissionDataApiV2SubmissionsOrgIdDataPost.PATH = '/api/v2/submissions/{org}/{id}/data';
